export const formatThreeShapeCaseName = (firstName?: string, lastName?: string, threeShapeOrderNo?: string): string =>
  firstName && lastName && threeShapeOrderNo ? `${lastName} ${firstName} - ${threeShapeOrderNo}` : ""
